export default "__VITE_ASSET__CzHdWsWG__"